import { defineStore } from 'pinia';
import { ref } from 'vue';
import { $axios } from 'boot/axios';

export const useDocumentsStore = defineStore('documents', () => {
  const bookPreview = ref(null);

  async function getBookPreviewBySlug({
    domain,
    bookSlug,
    readerAccessToken,
    preview,
  }) {
    let route = `public/route?url=https://${domain}/book/${bookSlug}`;
    if (preview) {
      route += '?preview=1';
    }
    const { data } = await $axios.get(route, {
      headers: {
        ReaderAccessToken: readerAccessToken || '',
      },
    });
    const {
      entry,
      entryKey,
    } = data.data;

    if (entryKey === 'book') {
      bookPreview.value = entry;
    }
  }

  return {
    bookPreview,
    getBookPreviewBySlug,
  };
});
